/** Aggregate reconciliation state for list/detail badges (derived from delivery lines). */
export type SupplyDeliveryLinesStatus = 'no_lines' | 'complete' | 'partial' | 'pending';

export function computeSupplyDeliveryLinesStatus(
  lines: Array<{
    isDelivered?: boolean | null;
    purchaseOrderQty?: number | null;
    deliveryQty?: number | null;
  }> | null | undefined,
): SupplyDeliveryLinesStatus {
  const list = lines ?? [];
  if (list.length === 0) return 'no_lines';
  let issueCount = 0;
  for (const line of list) {
    if (supplyApiLineHasIssue(line)) issueCount += 1;
  }
  if (issueCount === 0) return 'complete';
  if (issueCount === list.length) return 'pending';
  return 'partial';
}

/** True when a line is not fully marked delivered, or delivered qty ≠ PO qty. */
export function supplyApiLineHasIssue(line: {
  isDelivered?: boolean | null;
  purchaseOrderQty?: number | null;
  deliveryQty?: number | null;
}): boolean {
  if (line.isDelivered !== true) return true;
  const po = line.purchaseOrderQty;
  const d = line.deliveryQty;
  if (po != null && d != null && po !== d) return true;
  return false;
}

type FormLineLike = {
  isDelivered: boolean;
  itemId: string;
  itemDescription: string;
  purchaseOrderQty: string;
  deliveryQty: string;
};

function strToNumOrNull(s: string | undefined | null): number | null {
  if (s == null || s.trim() === '') return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

export function formLineIsMeaningful(line: FormLineLike): boolean {
  return (
    Boolean(line.itemId) ||
    Boolean(line.itemDescription?.trim()) ||
    Boolean(line.purchaseOrderQty?.trim()) ||
    Boolean(line.deliveryQty?.trim())
  );
}

export function formLineHasIssue(line: FormLineLike): boolean {
  if (!line.isDelivered) return true;
  const po = strToNumOrNull(line.purchaseOrderQty);
  const d = strToNumOrNull(line.deliveryQty);
  if (po != null && d != null && po !== d) return true;
  return false;
}
